export const navigationHeaderHeightLargeMobile = 122
export const navigationHeaderHeightLarge = 152
export const navigationHeaderHeightSmall = 110

export const getNavigationHeaderY = (isMobile: boolean) =>
	isMobile
		? navigationHeaderHeightLargeMobile - navigationHeaderHeightSmall
		: navigationHeaderHeightLarge - navigationHeaderHeightSmall
export const baseUrl = process.env.NEXT_PUBLIC_API_URL || ''

// Prismic
const PRISMIC_REPOSITORY = process.env.PRISMIC_REPOSITORY_NAME
const PRISMIC_REF_API_URL = `https://${PRISMIC_REPOSITORY}.cdn.prismic.io/api/v2`
const PRISMIC_GRAPHQL_API_URL = `https://${PRISMIC_REPOSITORY}.cdn.prismic.io/graphql`
const PRISMIC_API_TOKEN = process.env.PRISMIC_API_TOKEN
const PRISMIC_API_LOCALE = process.env.PRISMIC_REPOSITORY_LOCALE
const PRISMIC_API_DEFAULT_LOCALE = 'is'

export const prismicConstants = {
	repository: PRISMIC_REPOSITORY,
	refApiUrl: PRISMIC_REF_API_URL,
	gqlApiUrl: PRISMIC_GRAPHQL_API_URL,
	apiToken: PRISMIC_API_TOKEN ?? '',
	apiLocale: PRISMIC_API_LOCALE,
	apiDefaultLocale: PRISMIC_API_DEFAULT_LOCALE,
}

// Pages showing the site alert regenerate this often so Prismic edits go live quickly
export const SITE_ALERT_REVALIDATE_SECONDS = 60

export const ANSWERS_CONTAINER_ID = 'answersContainer'
export const Links = {
	iosAppLink: 'https://apps.apple.com/us/app/au%C3%B0ur/id1523911435',
	androidAppLink: 'https://play.google.com/store/apps/details?id=com.kvika.audur',
}

export const MaxLoanToPropertyValue = 0.65
export const MinPrincipalAmount = 2_000_000

// First installment number where the post-3-year future rate kicks in (3 years × 12 months + 1).
export const FutureRateFirstInstallment = 37
